import React, { useEffect, useMemo, useState } from "react";
import { useManualUpdate, useTrackerData } from "./store";
import TrackerTableData from "./TrackerTableData";
import { Select } from "antd";
import { useProductMapping } from "modules/dashboards/actionables/store";

function TrackerData() {
  const { trackerData, trackerLoading, fetchTrackerData } = useTrackerData();
  const [selectedWarehouse, setSelectedWarehouse] = useState(undefined);
  const [selectedSku, setSelectedSku] = useState(undefined);
  const [sortedData, setSortedData] = useState([]);
  const { productsData, isLoading, fetchProducts } = useProductMapping();
  const { wareHousesData, fetchWareHouses } = useManualUpdate();

  useEffect(() => {
      fetchProducts();
      fetchWareHouses();
  }, []);

  useEffect(() => {
      fetchTrackerData(selectedWarehouse, selectedSku);
  }, [selectedWarehouse, selectedSku]);

  useEffect(() => {
    setSortedData(trackerData?.mainData);
  }, [trackerData]);

  const skus = useMemo(() => {
    return (
      Array.isArray(productsData) &&
      productsData?.map((item) => ({
        value: item?.id,
        label: item?.medicine.display_name,
      }))
    );
  }, [productsData]);

  const warehouses = useMemo(() => {
    return wareHousesData?.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }, [wareHousesData]);

  const handleWarehouseFilterChange = (e) => {
    if (e) {
      setSelectedWarehouse(e);
    } else {
      setSelectedWarehouse(undefined);
    }
  };

  const handleSkuFilterChange = (e) => {
    if (e) {
      setSelectedSku(e);
    } else {
      setSelectedSku(undefined);
    }
  };

  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex">
        <Select
          style={{ width: "30%" }}
          placeholder="To Warehouse"
          options={warehouses}
          allowClear
          onChange={handleWarehouseFilterChange}
        />
        <Select
          style={{ width: "30%" }}
          placeholder="Select Skus"
          options={skus}
          allowClear
          onChange={handleSkuFilterChange}
        />
      </div>
      <TrackerTableData isLoading={trackerLoading} trackerData={sortedData} />
    </div>
  );
}

export default TrackerData;
